(ns hai.ui.components.collection.utils)

(defn deep-some
  [data pred]
  (->> data
       (tree-seq coll? seq)
       (some #(when (pred %) %))))

(defn ->id
  "Given either a table entity or table ID return the table ID."
  [?table]
  (or (:table/id ?table)
      ?table))

(defn ->table
  "Given either a table ID or a table entity/props containing a table ID, retrieve the table from
  the app-db. If there is no table in the app-db return the `?table` argument if it's a table
  entity."
  [db ?table]
  (let [id (->id ?table)
        table (get-in db [:collections id]
                      (and (map? ?table)
                           (contains? ?table :table/id)
                           ?table))]
    (or table (throw (ex-info "No table found" {:?table ?table})))))
